import { withStyles } from "@material-ui/core/styles";
import EstadoReconocimientos from "./EstadoReconocimientos";
import styles from "./styles";

export default withStyles(styles)(EstadoReconocimientos);
